<template>
  <main class="manifest-app p-page__section theme--light--alt mds" data-test="main-holder" id="main">
    <url-migration-notification />
    <router-view :key="$route.path" />
  </main>
</template>

<script>
import { Closest, Finally } from "@/lib/_polyfill.js";
import { mapActions } from "vuex";
import { RumInit } from "@maersk-global/telemetry-web-sdk";
import { getCurrentEnvironmentVariables } from "@/lib/CONSTANTS.js";
import UrlMigrationNotification from "@/components/common/UrlMigrationNotification.vue";

export default {
  name: "AgentManifest",
  components: {
    UrlMigrationNotification
  },
  data() {
    return {
      loading: null
    };
  },
  methods: {
    ...mapActions("commonStore", ["fetchBaseData"])
  },
  mounted() {
    Finally();
    Closest();
    this.fetchBaseData();
  }
};
RumInit({
  app: {
    name: getCurrentEnvironmentVariables().applicationName,
    version: "1.0.0",
    environment: getCurrentEnvironmentVariables().env
  },
  apiKey: getCurrentEnvironmentVariables().apiKey,
  performanceInstrument: { ignoreEvents: ["msal.*", ".*vue.*"] },
  traceLog: false
});
</script>
